import * as Types from '../../../__generated__/schema';

import { UserTeaser } from './UserTeaser.generated';
import { AlertDeliveryFull } from './AlertDeliveryFull.generated';
import { ActorTeaserAPIToken, ActorTeaserUser } from './ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from './ActorTeaser.generated';
export type AlertDetailsFull = Pick<
  Types.Alert,
  | 'id'
  | 'type'
  | 'title'
  | 'createdAt'
  | 'firstEventOccurredAt'
  | 'description'
  | 'reference'
  | 'runbook'
  | 'deliveryOverflow'
  | 'lastReceivedEventAt'
  | 'severity'
  | 'status'
  | 'updatedAt'
  | 'quality'
  | 'contextTags'
> & {
  assignee?: Types.Maybe<UserTeaser>;
  deliveries: Array<Types.Maybe<AlertDeliveryFull>>;
  updatedBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
};

export const AlertDetailsFull = gql`
  fragment AlertDetailsFull on Alert {
    id
    assignee {
      ...UserTeaser
    }
    type
    title
    createdAt
    firstEventOccurredAt
    description
    reference
    runbook
    deliveries {
      ...AlertDeliveryFull
    }
    deliveryOverflow
    lastReceivedEventAt
    severity
    status
    updatedBy {
      ...ActorTeaser
    }
    updatedAt
    quality
    contextTags
  }
  ${UserTeaser}
  ${AlertDeliveryFull}
  ${ActorTeaser}
`;
